<template>
  <div class="carousel-indicators" role="tablist" aria-label="Carousel-navigation">
    <button
      class="carousel-indicator-item"
      :class="{ active: active === index }"
      v-for="(item, index) in count"
      :key="index"
      :id="key"
      role="tab"
      @click="scroll(index)"
    >
  <span class="sr-only" v-if="index === 0">Slide for Life Skills </span>
  <span class="sr-only" v-if="index === 1">Slide for College Planning </span>
  <span class="sr-only" v-if="index === 2">Slide for Financial Wellness </span>
  <span class="sr-only" v-if="index === 3">Slide for Military Readiness </span>
  <span class="sr-only" v-if="index === 4">Jobs and Careers </span>
  <span class="sr-only" v-else>Slide {{ index + 1 }}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: ["count", "active", "slides"],
  methods: {
    scroll(slideNum) {
      this.$emit('switch', slideNum);
      const element = document.getElementById("hp-carousel");
      let x = element.scrollWidth / this.slides.length;
      element.scrollLeft = x * slideNum;
    }
  }
};
</script>

<style scoped>
.carousel-indicators {
  z-index: 10;
  position: relative;
  top: 0px;
  margin-bottom: 83px;
}

.carousel-indicator-item {
  border: none;
  width: 12px;
  height: 12px;
  background-color: #888888;
  border-radius: 50%;
  opacity: 0.5;
  margin: 4px;
  cursor: pointer;
}

.active {
  opacity: 1;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0px;
  margin: -1px;
  overflow: hidden;
  clip: rest(0,0,0,0);
  white-space: nowrap;
  border: 0px;
}
</style>